
import { Options, Vue } from 'vue-class-component';
import FieldDatePicker from '@/components/fields/FieldDatePicker.vue';
import FieldTotalSelector from '@/components/fields/FieldTotalSelector.vue';
import AvailabilityBox from '@/components/availability/AvailabilityBox.vue';
import Button from '@/components/atoms/Button.vue';
import * as API from '@/api/book';

@Options({
    components: {
        FieldDatePicker,
        FieldTotalSelector,
        AvailabilityBox,
        Button,
    },
    props: {
        categoryId: String,
    },
})

export default class AvailabilityApp extends Vue {

    // Props
    categoryId!: string;

    error: Error | null = null;
    category: API.AccommodationJson | null = null;
    busy = true;


    async mounted() {
        this.busy = true;

        try {
            this.category = await API.getItem(this.categoryId);
            this.busy = false;
        }
        catch (error: any) {
            this.error = error;
        }
    }
}
